import { useMemo } from 'react';
import type { GroupedOptionsType } from '../../common-ui/form-fields/Dropdown';
import { getGroupedOptionsBySeaArea } from '../utils/getGroupedOptionsBySeaArea';
import type { DropdownOption } from '../utils/optionTransformers';
import type { Route } from './fragments/gql/Route';
import type { QueryResult } from './types/QueryResult';
import { useAllRoutes } from './useAllRoutes';

export const useAllRoutesAsOptions = (options?: {
  skip?: boolean;
  includeClosedRoutes?: boolean;
}): QueryResult<GroupedOptionsType<DropdownOption<Route>>> => {
  const [routes, loading, error] = useAllRoutes(options);

  const groupedRoutes = useMemo(() => getGroupedOptionsBySeaArea(routes), [routes]);

  return [groupedRoutes, loading, error];
};
